import { cn } from '@/utilities/ui'

type BetaFeatureTagProps = Readonly<{
  className?: string
  'data-testid'?: string
}>

export default function BetaFeatureTag({
  className,
  'data-testid': dataTestId = 'beta-feature-tag',
}: BetaFeatureTagProps) {
  return (
    <span
      className={cn(
        'inline-block rounded bg-cp-beta-bg px-1.5 py-0.5 text-xs leading-tight whitespace-nowrap text-cp-beta-text',
        className,
      )}
      data-testid={dataTestId}
    >
      Beta
    </span>
  )
}
